<section class="px-4 py-16">
  <h2 class="text-2xl sm:text-3xl font-bold mb-10 text-center text-white-800">
    Explora por categorías
  </h2>

  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8"
    appAnimateStagger
  >
    @for (c of categories; track c) {
      <app-galaxy-card #staggerItem padding="lg">
        <div galaxy-card-content class="flex flex-col items-center text-center">
          <h3 class="text-xl font-semibold mb-2 text-white-800">
            {{ c.name }}
          </h3>
          <a
            [routerLink]="['/tienda']"
            [queryParams]="{ category: c.id }"
            appGalaxyButton
            appGalaxyRipple
            galaxyVariant="secondary"
            galaxySize="sm"
            class="mt-4"
          >
            Ver productos
          </a>
        </div>
      </app-galaxy-card>
    }
  </div>
</section>
